import globalText from "../../../../../utils/globalText";
import Loader from "../../../../Loader/Index";
import CommonLayout from "../../../../_utils/CommonLayout";
import Amount from "../../../../_utils/TransactionCommonComponents/Amount";
import PaymentMethodSelector from "../../../../_utils/TransactionCommonComponents/PaymentMethodSelector";

const BeneficiaryTransactionStepAmount = ({
  txnPayLoad,
  isNeft,
  isRtgs,
  copyData,
  setCopyData,
  txnLoading,
  slideAnimation,
  handleAmountChange,
  handleRtgsClick,
  handleNeftClick,
}) => {
  return (
    <div className="relative w-width-full">
    

      <div
        className={`w-width-full Qlg:px-padding-base px-padding-md py-padding-md max-w-tab-width-normal mx-auto ${
          txnLoading ? "pointer-events-none" : ""
        }`}
      >
        <CommonLayout>
          <Amount
            title={globalText?.AMOUNT}
            amount={txnPayLoad?.amount}
            amountInWords={txnPayLoad?.amountInWords}
            copyData={copyData}
            onAmountChange={(val) =>
              handleAmountChange({ name: "amount", value: val })
            }
            onPasteApplied={() => {
              if (copyData?.title === "Transfer Amount") {
                const pastedValue = copyData?.value?.toString();
                handleAmountChange({
                  name: "amount",
                  value: pastedValue,
                });
              }
              setCopyData({ title: "", data_type: "", value: "" });
            }}
            isPreview={false}
          />

          <PaymentMethodSelector
            title={globalText?.SELECT_PAYMENT_METHOD}
            slideAnimation={slideAnimation}
            previewMode={false}
            methods={[
              {
                key: "neft",
                label: globalText?.NEFT,
                subText: globalText?.NEFT_TRANSFER_NOTE,
                active: isNeft,
                notes: [
                  globalText?.TRANSACTION_EXECUTION_NOTE,
                  globalText?.TRANSACTION_LIMIT_NOTE,
                  globalText?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: handleNeftClick,
              },
              {
                key: "rtgs",
                label: globalText?.RTGS,
                subText: globalText?.INSTANT_TRANSFER_NOTE,
                active: isRtgs,
                notes: [
                  globalText?.RTGS_TRANSACTION_EXECUTION_NOTE,
                  globalText?.RTGS_TRANSACTION_LIMIT_NOTE,
                  globalText?.TRANSACTION_CHARGES_NOTE,
                ],
                onClick: handleRtgsClick,
              },
            ]}
          />
        </CommonLayout>
      </div>
    </div>
  );
};

export default BeneficiaryTransactionStepAmount;
